import getAllAffectedNodes from './utils/all-affected';
import { arrayFind, toArray } from './utils/array';

var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};

var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!arrayFind(toArray(topNode.querySelectorAll('iframe')), focusInFrame);
};

var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;

  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};

export default focusInside;


//////////////////
// WEBPACK FOOTER
// ./~/focus-lock/dist/es2015/focusInside.js
// module id = 994
// module chunks = 0